export { default } from './Popper';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Popper/index.js
// module id = 460
// module chunks = 121